import React from "react";
import { Button } from "react-bootstrap";
import { bool, func, object } from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { scheduleDemoManageMenu } from "../helpers";
import "!style-loader!css-loader!../styles.css";

const UpgradeBanner = ({ isFreeTrial, userData, dispatch, closeDropdown }) => {
  const handleButtonClick = () => {
    if (isFreeTrial) {
      const utmParameters = {
        content: "free_trial_se",
        campaign: "manage_menu",
        source: "platform",
        medium: userData?.companyAccountId,
      };

      const url = scheduleDemoManageMenu(
        isFreeTrial,
        userData.rep,
        userData.numberOfEmployees,
        utmParameters
      );

      window.open(url, "_blank", "noopener");
    } else {
      // Close the dropdown before navigating
      if (closeDropdown) {
        closeDropdown();
      }
      dispatch(push("/packagingPage"));
    }
  };

  return (
    <div className="manage-menu-upgrade-banner">
      <span className="upgrade-tag">
        {isFreeTrial ? "Subscribe" : "Upgrade"}
      </span>
      <p className="mb-0">
        Unlock configuration flexibility that fits your hiring needs
      </p>
      <Button
        variant="outline-primary"
        className="btn-cancel secondaryActionBtn p-0 mr-0 align-items-center font-weight-bold"
        onClick={handleButtonClick}
      >
        <span>{isFreeTrial ? "Schedule a Demo" : "Compare Plans"}</span>
      </Button>
    </div>
  );
};

UpgradeBanner.propTypes = {
  isFreeTrial: bool,
  userData: object,
  dispatch: func,
  closeDropdown: func,
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(null, mapDispatchToProps)(UpgradeBanner);
